import formValidation from "./validations";
import { showToastAction } from "store/slices/commonSlice";

export const HandleAdd = (inputs, AllValues, setAllValues) => {
    const values = [...AllValues];
    values.push(inputs);
    setAllValues(values);
}

export const handleChange = (name, value, index, allValues, setAllValues, ignoreInputs = [], optional = [], mediaType, thanField, maxSize, minSize) => {
    console.log("name", name, value)
    const updatedArray = [...allValues];
    if (index > -1 && index < updatedArray.length) {
        let formErrors = {}
        if (name === "link") {
            formErrors = formValidation(name, { type: mediaType, value: value }, updatedArray[index], ignoreInputs, optional);
        } else {
            formErrors = formValidation(name, value, updatedArray[index], ignoreInputs, optional, "", thanField, maxSize, minSize);
        }
        updatedArray[index] = { ...updatedArray[index], [name]: value, formErrors, };
        setAllValues && setAllValues(updatedArray);
    }
};

export const handleSave = (index, allValuesArray, setAllValues, ignoreInputs = [], optional = [], thanField) => {
    const values = [...allValuesArray];
    let hasErrors = false
    const fieldKeys = Object.keys(values[index]);
    fieldKeys.forEach((key) => {
        let formErrors = {}
        const value = values[index][key];
        if (key === "link") {
            formErrors = formValidation(key, { type: values[index]["type"], value: value }, values[index], ignoreInputs, optional);
        } else {
            formErrors = formValidation(key, value, values[index], ignoreInputs, optional, "", thanField, "", values[index][thanField])
        }

        values[index] = { ...values[index], [key]: value, formErrors };
        if (formErrors[key]) {
            hasErrors = true;
        }
    });
    if (!hasErrors) {
        values[index].status = "save"
    }
    setAllValues(values)
    return hasErrors
};

export const handleDelete = (allValuesArray, setAllValues, index, required, dispatch, name) => {
    let values = [...allValuesArray]

    if (values?.length !== required) {
        let filtered = values.filter((item, itemIndex) => itemIndex !== index)
        setAllValues(filtered)
        return filtered
    } else {
        dispatch(showToastAction({
            type: "error",
            detail: `At least ${required} ${name} is required.`
        }))
    }
}

export const handlEdit = (allValuesArray, setAllValues, index) => {
    const values = [...allValuesArray];
    if (index > -1) {
        values[index].status = "edit";
    }
    setAllValues(values);
};

// export const checkErrors = (allValues, setAllValues, keysToCheck = [], optional = []) => {
//     let hasErrors = false;

//     const updatedValues = allValues.map((item) => {
//         // Dynamically check for keys provided in the keysToCheck array
//         const shouldValidate = keysToCheck.some((key) => item?.[key]);

//         if (shouldValidate && item.status !== "save") {
//             const fieldKeys = Object.keys(item);
//             let formErrors = {};

//             fieldKeys.forEach((key) => {
//                 const value = item[key];
//                 const errors = formValidation(key, value, item, ["id", "status"], optional);
//                 formErrors = { ...formErrors, ...errors };

//                 // Update the error status if there are any errors
//                 if (errors[key]) {
//                     hasErrors = true;
//                 }
//             });

//             return { ...item, formErrors, status: hasErrors ? item.status : "save" };
//         }

//         return item.status !== "save" ? null : item;
//     }).filter(Boolean);

//     setAllValues(updatedValues);

//     // Return the results
//     return { hasErrors, values: updatedValues };
// };

export const checkErrors = (allValues, setAllValues, keysToCheck = [], optional = [], required = 0, thanField) => {
    let hasErrors = false;
    let validItems = []; // Array to store items that meet the filled condition
    // Iterate through each item in the allValues array
    const updatedValues = allValues.map((item) => {
        let filledCount = 0;  // Reset filledCount for each item
        const shouldValidate = keysToCheck.some((key) => item?.[key]);
        let formErrors = {};

        if (shouldValidate || required) {
            const fieldKeys = Object.keys(item);

            fieldKeys.forEach((key) => {
                const value = item[key];

                const errors = formValidation(key, value, item, ["id", "status"], optional, "", thanField, "", item[thanField])

                // formErrors = { ...formErrors, ...errors };

                // Update the error status if there are any errors
                if (errors[key]) {
                    formErrors = { ...formErrors, ...errors }
                    hasErrors = true;
                }

                // If the value is not empty, increment the filledCount
                if (value && value !== '') {
                    filledCount += 1;
                }
            });

            // If this object has at least `required` filled fields, add it to validItems
            if (filledCount >= required) {
                validItems.push({ ...item, formErrors, status: hasErrors ? "edit" : "save" });
            }
        }
        return { ...item, formErrors, status: hasErrors ? item.status : "save" };
    });

    // If no valid items meet the required criteria, return the first `required` items
    if (validItems.length === 0) {
        validItems = updatedValues.slice(0, required);  // Keep the first `required` items only
    }

    // Update the allValues with the filtered list (valid items or just the first)
    setAllValues(validItems);

    // Return the results
    return { hasErrors, values: validItems };
};